import React, { useEffect, useState } from "react";

// Import หน้าจอ BillOfSale มาแสดงบน Modal
import Form from "../../pages/SellProducts/BillOfSale/Form";

// Report
import { getReport } from "../../../utils/ReportUtils";
import {
  formatCurrency,
  getAlert,
  getDataWithComp,
  useEscapeClose,
  getData,
  getMultipleSlips,
} from "../../../utils/SamuiUtils";
import { formatDate } from "../../../utils/DateUtils";

const ViewSoModal = ({
  showViewSoModal,
  handleViewSoClose,
  mode,
  name,
  maxDocNo,
}) => {
  const [docStatusTransportName, setDocStatusTransportName] = useState("");
  const [docStatusTransportColor, setDocStatusTransportColor] = useState("");
  const [docStatusPaidName, setDocStatusPaidName] = useState("");
  const [docStatusPaidColor, setDocStatusPaidColor] = useState("");
  const [docStatusPaidTypeName, setDocStatusPaidTypeName] = useState("");
  const [docStatusPaidTypeColor, setDocStatusPaidTypeColor] = useState("");

  const [payAmount, setPayAmount] = useState(0);
  const [paymentHistory, setPaymentHistory] = useState([]);

  // สำหรับจัดการ Slip Modal
  const [showSlipModal, setShowSlipModal] = useState(false);
  const [uploadedSlipFiles, setUploadedSlipFiles] = useState([]);

  // สำหรับข้อมูลธนาคาร
  const [masterBankDataList, setMasterBankDataList] = useState([]);
  const [bankDataList, setBankDataList] = useState([]);
  const [payDatetime, setPayDatetime] = useState("");

  useEscapeClose(showViewSoModal, handleViewSoClose);

  useEffect(() => {
    if (maxDocNo) {
      initialize();
      loadBankData();
    }
  }, [maxDocNo]);

  const initialize = async () => {
    try {
      const getSoByNo = await getDataWithComp(
        "API_0701_SO_H",
        `AND Doc_No = '${maxDocNo}'`
      );

      if (getSoByNo && getSoByNo.length > 0) {
        const soData = getSoByNo[0];
        setDocStatusTransportName(soData.DocStatusTransport_Name);
        setDocStatusTransportColor(soData.DocStatusTransport_Colour);
        setDocStatusPaidName(soData.DocStatusPaid_Name);
        setDocStatusPaidColor(soData.DocStatusPaid_Colour);
        setDocStatusPaidTypeName(soData.DocStatusPaid_Type_Name);
        setDocStatusPaidTypeColor(soData.DocStatusPaidType_Colour);

        switch (soData.Doc_Status_Paid_Type) {
          case 1:
          case 2:
          case 3:
          case 6:
            setPayAmount(soData.Pay_Total);
            break;
          case 4:
          case 5:
            setPayAmount(soData.NetTotal);
            break;
          default:
            setPayAmount(0);
            break;
        }

        // ดึงประวัติการชำระเงิน
        const paymentHistoryResponse = await getData(
          "Pay_History",
          `DocCode_Id = 7 AND Doc_Id = ${soData.Doc_ID}`
        );

        if (paymentHistoryResponse && paymentHistoryResponse.length > 0) {
          setPaymentHistory(paymentHistoryResponse);
          // ใช้ payment แรกสำหรับ payDatetime
          setPayDatetime(
            formatDate(paymentHistoryResponse[0].Pay_Datetime, false)
          );
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const loadBankData = async () => {
    try {
      const masterBankData = await getData(
        "Tb_Set_Bank_Master",
        "1 = 1 ORDER BY Bank_Master_Id ASC"
      );
      if (masterBankData && masterBankData.length > 0) {
        setMasterBankDataList(masterBankData);
      }

      const bankDataList = await getDataWithComp(
        "View_Set_Bank",
        "AND Bank_Status = 'Y' ORDER BY Bank_Id ASC"
      );
      if (bankDataList && bankDataList.length > 0) {
        setBankDataList(bankDataList);
      }
    } catch (error) {
      console.error("Error loading bank data:", error);
    }
  };

  useEffect(() => {
    const fetchUploadedFiles = async () => {
      if (paymentHistory.length > 0 && showSlipModal) {
        try {
          const docId = paymentHistory[0].Doc_Id;
          const docCodeId = 7; // SO

          if (docId) {
            const files = await getMultipleSlips(docId, docCodeId);
            setUploadedSlipFiles(files);
          }
        } catch (error) {
          console.error("Error fetching uploaded files:", error);
        }
      }
    };

    fetchUploadedFiles();
  }, [paymentHistory, showSlipModal]);

  const handleSlipButtonClick = () => {
    setShowSlipModal(true);
  };

  return (
    <>
      <div
        className={`modal fade ${showViewSoModal ? "show" : ""}`}
        style={{
          display: showViewSoModal ? "block" : "none",
          overflowY: "auto",
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        }}
        tabIndex="-1"
        role="dialog"
      >
        <div
          className="modal-dialog modal-xl"
          role="document"
          style={{
            maxWidth: "90%",
            margin: "1.75rem auto",
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="card-title">{name || "รายละเอียดใบขาย"}</h4>

              {/* สถานะส่งสินค้า */}
              <div style={{ display: "flex", marginLeft: "10px" }}>
                <div
                  className="page-header col-12"
                  style={{ marginBottom: "-1px" }}
                >
                  <button
                    className="btn btn-md w-100"
                    style={{
                      backgroundColor: docStatusTransportColor,
                      fontSize: "16px",
                      color: "white",
                      pointerEvents: "none",
                      userSelect: "none",
                    }}
                  >
                    {docStatusTransportName}
                  </button>
                </div>
              </div>

              {/* สถานะจ่าย */}
              <div style={{ display: "flex", marginLeft: "10px" }}>
                <div
                  className="page-header col-12"
                  style={{ marginBottom: "-1px" }}
                >
                  <button
                    className="btn btn-md w-100"
                    style={{
                      backgroundColor: docStatusPaidColor,
                      fontSize: "16px",
                      color: "white",
                      pointerEvents: "none",
                      userSelect: "none",
                    }}
                  >
                    {docStatusPaidName}
                  </button>
                </div>
              </div>

              {/* ประเภทการจ่าย */}
              {docStatusPaidTypeName === "จ่ายหลายช่องทาง" ? (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginLeft: "10px",
                  }}
                >
                  {paymentHistory.map((pay, index) => (
                    <button
                      key={index}
                      className="btn btn-md"
                      style={{
                        backgroundColor:
                          pay.Pay_Type === 1
                            ? "green"
                            : pay.Pay_Type === 2
                            ? "blue"
                            : pay.Pay_Type === 3
                            ? "purple"
                            : "gray",
                        fontSize: "16px",
                        color: "white",
                        userSelect: "none",
                      }}
                      onClick={() => {
                        if (pay.Pay_Type === 2) {
                          handleSlipButtonClick();
                        }
                      }}
                    >
                      {pay.Pay_Type === 1
                        ? "เงินสด"
                        : pay.Pay_Type === 2
                        ? "เงินโอน"
                        : pay.Pay_Type === 3
                        ? "เช็ค"
                        : "ไม่ทราบ"}{" "}
                      ({formatCurrency(pay.Pay_Amount)} ฿)
                      {pay.Pay_Type === 2 && (
                        <i
                          className="fas fa-search-plus ml-2"
                          style={{ fontSize: "14px" }}
                        ></i>
                      )}
                    </button>
                  ))}
                </div>
              ) : (
                <div style={{ display: "flex", marginLeft: "10px" }}>
                  <div
                    className="page-header col-12"
                    style={{ marginBottom: "-1px" }}
                  >
                    <button
                      className="btn btn-md w-100"
                      style={{
                        backgroundColor: docStatusPaidTypeColor,
                        fontSize: "16px",
                        color: "white",
                        userSelect: "none",
                      }}
                      onClick={() => {
                        if (docStatusPaidTypeName === "เงินโอน") {
                          handleSlipButtonClick();
                        }
                      }}
                    >
                      {docStatusPaidTypeName}{" "}
                      {payAmount > 0
                        ? `(${formatCurrency(payAmount)} ฿)`
                        : null}{" "}
                      {docStatusPaidTypeName === "เงินโอน" && (
                        <i
                          className="fas fa-search-plus"
                          style={{ fontSize: "16px" }}
                        ></i>
                      )}
                    </button>
                  </div>
                </div>
              )}

              <div style={{ marginLeft: "auto", marginRight: "30px" }}>
                <button
                  className="btn btn-lg btn-success"
                  onClick={() => getReport("rc", maxDocNo)}
                  style={{
                    fontSize: "18px",
                    color: "white",
                    marginRight: "30px",
                  }}
                >
                  พิมพ์ใบแจ้งยอดเงิน
                </button>
                <button
                  className="btn btn-lg btn-primary"
                  onClick={() => getReport("so", maxDocNo)}
                  style={{
                    fontSize: "18px",
                    color: "white",
                  }}
                >
                  พิมพ์ใบขาย
                </button>
              </div>
              <button
                type="button"
                className="close"
                onClick={handleViewSoClose}
                style={{ fontSize: "1.5rem" }}
              >
                <span>&times;</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "70vh", overflowY: "auto" }}
            >
              {/* เรียกใช้ฟอร์มที่ต้องการ */}
              <Form
                callInitialize={null}
                mode={mode}
                name={name}
                maxDocNo={maxDocNo}
                getReport={null}
              />
            </div>
            <div className="modal-footer">
              <button className="btn btn-danger" onClick={handleViewSoClose}>
                ปิด
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal สำหรับแสดงสลิปเงินโอน - ดูอย่างเดียว */}
      {showSlipModal && (
        <div
          className="modal"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog modal-md" role="document">
            <div
              className="modal-content shadow-lg"
              style={{
                borderRadius: "15px",
                overflow: "hidden",
                maxHeight: "auto",
              }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "#EF6C00",
                  borderBottom: "none",
                  padding: "15px",
                }}
              >
                <h5 className="modal-title fw-bold text-white">
                  สลิปการชำระเงิน {payDatetime && `เมื่อวันที่ ${payDatetime}`}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowSlipModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div
                className="modal-body"
                style={{
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {uploadedSlipFiles.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <h4>ไม่พบรูปภาพสลิป</h4>
                    <p className="text-muted">
                      ยังไม่มีการอัพโหลดสลิปสำหรับการชำระเงินนี้
                    </p>
                  </div>
                ) : (
                  <div style={{ width: "100%" }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="fw-bold mb-0">
                        ไฟล์สลิปที่อัพโหลดแล้ว ({uploadedSlipFiles.length} ไฟล์)
                      </h5>
                    </div>

                    <div className="row g-3">
                      {uploadedSlipFiles.map((file, index) => (
                        <div key={file.id} className="col-12">
                          <div
                            className="card"
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              overflow: "hidden",
                            }}
                          >
                            <div className="card-header bg-light d-flex justify-content-between align-items-center py-2">
                              <span className="fw-bold">
                                ไฟล์ที่ {index + 1}: {file.fileName}
                              </span>
                            </div>
                            <div className="card-body p-2">
                              <img
                                src={file.fileUrl}
                                alt={`สลิปที่ ${index + 1}`}
                                style={{
                                  width: "100%",
                                  maxHeight: "300px",
                                  objectFit: "contain",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  window.open(file.fileUrl, "_blank")
                                }
                              />
                              <div className="mt-2 text-muted small">
                                อัพโหลดโดย: {file.uploadBy} | วันที่:{" "}
                                {formatDate(file.uploadDate)}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* ส่วนรายละเอียดธนาคาร */}
                <div style={{ width: "100%", marginTop: "20px" }}>
                  <h5
                    className="fw-bold mb-3"
                    style={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "8px",
                    }}
                  >
                    รายละเอียดธนาคาร
                  </h5>
                  <div style={{ marginBottom: "12px" }}>
                    <span className="fw-bold">ธนาคาร: </span>
                    <span>
                      {(() => {
                        const targetPayment = paymentHistory.find(
                          (p) => p.Pay_Type === 2
                        );
                        if (!targetPayment) return "-";
                        if (targetPayment.Bank_Id) {
                          const bank = bankDataList.find(
                            (b) => b.Bank_Id === targetPayment.Bank_Id
                          );
                          return bank ? bank.B_Name_TH : "-";
                        } else {
                          const bank = masterBankDataList.find(
                            (b) =>
                              b.Bank_Master_Id === targetPayment.Bank_Master_Id
                          );
                          return bank ? bank.B_Name_TH : "-";
                        }
                      })()}
                    </span>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <span className="fw-bold">เลขที่บัญชี: </span>
                    <span>
                      {(() => {
                        const targetPayment = paymentHistory.find(
                          (p) => p.Pay_Type === 2
                        );
                        if (!targetPayment) return "-";
                        if (targetPayment.Bank_Id) {
                          const bank = bankDataList.find(
                            (b) => b.Bank_Id === targetPayment.Bank_Id
                          );
                          return bank ? bank.Bank_Account || "-" : "-";
                        } else {
                          return targetPayment.Pay_To_Acc_No || "-";
                        }
                      })()}
                    </span>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <span className="fw-bold">ชื่อบัญชี: </span>
                    <span>
                      {(() => {
                        const targetPayment = paymentHistory.find(
                          (p) => p.Pay_Type === 2
                        );
                        if (!targetPayment) return "-";
                        if (targetPayment.Bank_Id) {
                          const bank = bankDataList.find(
                            (b) => b.Bank_Id === targetPayment.Bank_Id
                          );
                          return bank ? bank.Bank_Name_TH || "-" : "-";
                        } else {
                          return targetPayment.Pay_To_Acc_Name || "-";
                        }
                      })()}
                    </span>
                  </div>
                  {(() => {
                    const targetPayment = paymentHistory.find(
                      (p) => p.Pay_Type === 2
                    );
                    if (targetPayment && targetPayment.Bank_Id) {
                      const bank = bankDataList.find(
                        (b) => b.Bank_Id === targetPayment.Bank_Id
                      );
                      let label = "ชื่อเจ้าหนี้";
                      if (bank?.APAR_Type === "AR") {
                        label = "ชื่อลูกหนี้";
                      } else if (bank?.APAR_Type === "CP") {
                        label = "ชื่อบริษัท";
                      }
                      return (
                        <div>
                          <span className="fw-bold">{label}: </span>
                          <span>{bank?.NName || "-"}</span>
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewSoModal;
